// extracted by mini-css-extract-plugin
export var columnList = "_es-0";